<template>
  <div class="privacy-container">
    <!-- 顶部导航栏 -->
    <div class="privacy-header">
      <h1 class="privacy-title">利群数字资源平台隐私条款</h1>
      <div class="privacy-version">版本：V1.0 | 更新时间：2024-05-20</div>
    </div>
    <!-- 隐私条款内容区域（滚动显示） -->
    <div class="privacy-content">
      <h3>1 信息收集</h3>
      <p>1.1 服务相关信息：用户发布的文章内容、发布时间、支付记录等服务使用过程中产生的信息。</p>
      <p>1.2 技术信息：为保障服务安全，平台可能收集用户设备型号、IP地址等技术信息。</p>

      <h3>2 信息使用</h3>
      <p>2.1 用于为用户提供注册、文章发布、费用结算等核心服务。</p>
      <p>2.2 用于优化平台服务，提升用户体验，如分析用户使用习惯、改进审核机制等。</p>
      <p>2.3 法律法规要求或用户同意的其他合理用途。</p>

      <h3>3 信息保护与披露</h3>
      <p>3.1 平台将采取加密存储、访问控制等技术措施保护用户信息安全，防止信息泄露、篡改或丢失。</p>
      <p>3.2 未经用户同意，平台不会向第三方披露用户信息，但法律法规要求、保护平台合法权益或用户授权的情形除外。</p>

      <h3>4 用户权利</h3>
      <p>用户可联系企业客服查询、修改本人注册信息，账号注销后可要求平台删除相关个人信息（法律法规规定需留存的除外）。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  mounted() {
    // 滚动到页面顶部
    window.scrollTo(0, 0);
  }
};
</script>

<style scoped>
.privacy-container {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 20px;
  box-sizing: border-box;
}
.privacy-header {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
}
.privacy-title {
  font-size: 20px;
  color: #333;
  text-align: center;
  margin: 10px 0;
  font-weight: 600;
}
.privacy-version {
  font-size: 12px;
  color: #999;
  text-align: center;
}
.privacy-content {
  background-color: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  line-height: 1.8;
  color: #333;
  font-size: 14px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}
.privacy-content h3 {
  font-size: 16px;
  color: #222;
  margin: 20px 0 10px;
  font-weight: 600;
}
.privacy-content p {
  margin: 8px 0;
  text-indent: 2em;
}
/* 滚动条样式优化 */
.privacy-content::-webkit-scrollbar {
  width: 6px;
}
.privacy-content::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
}
/* 移动端适配 */
@media screen and (max-width: 768px) {
  .privacy-content {
    padding: 20px;
    max-height: calc(100vh - 180px);
  }
  .privacy-title {
    font-size: 18px;
  }
}
</style>